// eslint-disable-next-line import/prefer-default-export
import { decodeRSA } from '@/mixins/function';

const list = [{
  code: 'CL',
  name: 'Chile',
  area_1: 'Región',
  area_2: 'Comuna',
  area_3: 'Localidad',
  time_zone: 'America/Santiago',
  identity: { name: 'RUT', example: '11222333-4' },
  centroid: { lat: -33.4804016, lng: -70.6844507 },
  sites: [
    { url: 'https://www.openstreetmap.org', img: 'Openstreetmap_logo.png' },
    { url: 'https://wego.here.com', img: 'hereWeGo-logo.png' },
    { url: 'http://homer.sii.cl/', img: 'SII-logo.png' },
    { url: 'https://mapcity.com', img: 'Mapcity-logo.jpg' }],
}, {
  code: 'PE',
  name: 'Perú',
  area_1: 'Departamento',
  area_2: 'Distrito',
  area_3: 'Localidad',
  time_zone: 'America/Lima',
  identity: { name: 'DNI', example: '11222333' },
  centroid: { lat: -12.0264987, lng: -77.2679843 },
  sites: [
    { url: 'https://www.openstreetmap.org', img: 'Openstreetmap_logo.png' },
    { url: 'https://wego.here.com', img: 'hereWeGo-logo.png' },
    { url: 'https://www.mapcity.pe', img: 'Mapcity-logo.jpg' }],
}];

// eslint-disable-next-line import/prefer-default-export
export const tenantCode = () => {
  const code = `${decodeRSA(sessionStorage.country)}`;
  return list.map(t => t.code).includes(code) ? code : list[0].code;
};

// eslint-disable-next-line import/prefer-default-export
export const tenantSites = () => {
  const code = `${decodeRSA(sessionStorage.country)}`;
  return list.filter(t => t.code.indexOf(code) !== -1).flatMap(t => t.sites);
};

// eslint-disable-next-line import/prefer-default-export
export const tenantCentroid = () => {
  const code = `${decodeRSA(sessionStorage.country)}`;
  return list.filter(t => t.code.indexOf(code) !== -1).map(t => t.centroid)[0] || list[0].centroid;
};

// eslint-disable-next-line import/prefer-default-export
export const tenantIdentity = () => {
  const code = `${decodeRSA(sessionStorage.country)}`;
  return list.filter(t => t.code.indexOf(code) !== -1).map(t => t.identity)[0] || list[0].identity;
};

export const tenantTimeZone = () => {
  const code = `${decodeRSA(sessionStorage.country)}`;
  return list.filter(t => t.code.indexOf(code) !== -1)
    .map(t => t.time_zone)[0] || list[0].time_zone;
};
